import { Component } from '@angular/core';

@Component({
    selector: 'redispatch-westnetz-footer',
    templateUrl: './westnetz-footer.component.html',
    styleUrls: [
        './westnetz-footer.component.scss',
    ],
    standalone: false,
})
export class WestnetzFooterComponent {

    public currentYear = new Date().getFullYear();

    constructor() {
    }

}
